/**
 * GENERATED FILE - DO NOT EDIT BY HAND.
 *
 * How a client's money divides between the two halves of the guaranteed annuity shape, read out of
 * Challenger's aged care calculator by `scripts/import-careplus-split.py`. To update: save a newer
 * calculator over `docs/reference/aged_care_calculator.xlsm`, run the script, run
 * `npm run test:shared`, commit. Any hand edit here is lost on the next import.
 *
 * WHAT THE NUMBERS ARE. For each age and sex, the SHARE of the total invested that buys the life
 * policy (`insurance`) and the share that buys the lifetime annuity (`annuity`). They sum to 1. The
 * nil adviser fee column only. The insurance share rises with age because an older client's annuity
 * slice returns less, so more policy is needed to guarantee the same amount.
 *
 * WHY IT MATTERS. The two halves are means-tested differently: the annuity slice at 60% then 30% of
 * its price, the insurance slice at the greater of the premium paid and its surrender value. Without
 * this split the guaranteed shape cannot be modelled at all, only displayed.
 *
 * Source workbook valid to 2026-09-27. Imported 2026-09-27.
 */

export const CAREPLUS_SPLIT = {
    source: 'aged_care_calculator.xlsm',
    validTo: "2026-09-27",
    importedAt: '2026-09-27',
    male: {
        64: { insurance: 0.388817, annuity: 0.611183 },
        65: { insurance: 0.401169, annuity: 0.598831 },
        66: { insurance: 0.414398, annuity: 0.585602 },
        67: { insurance: 0.428604, annuity: 0.571396 },
        68: { insurance: 0.443855, annuity: 0.556145 },
        69: { insurance: 0.445541, annuity: 0.554459 },
        70: { insurance: 0.462189, annuity: 0.537811 },
        71: { insurance: 0.480045, annuity: 0.519955 },
        72: { insurance: 0.499123, annuity: 0.500877 },
        73: { insurance: 0.501533, annuity: 0.498467 },
        74: { insurance: 0.521805, annuity: 0.478195 },
        75: { insurance: 0.543186, annuity: 0.456814 },
        76: { insurance: 0.565762, annuity: 0.434238 },
        77: { insurance: 0.567768, annuity: 0.432232 },
        78: { insurance: 0.591599, annuity: 0.408402 },
        79: { insurance: 0.616852, annuity: 0.383148 },
        80: { insurance: 0.618637, annuity: 0.381363 },
        81: { insurance: 0.645397, annuity: 0.354603 },
        82: { insurance: 0.647057, annuity: 0.352943 },
        83: { insurance: 0.675442, annuity: 0.324558 },
        84: { insurance: 0.677033, annuity: 0.322968 },
        85: { insurance: 0.707085, annuity: 0.292915 },
        86: { insurance: 0.708660, annuity: 0.291340 },
        87: { insurance: 0.740326, annuity: 0.259674 },
        88: { insurance: 0.741951, annuity: 0.258049 },
        89: { insurance: 0.774986, annuity: 0.225014 },
        90: { insurance: 0.776714, annuity: 0.223286 },
        91: { insurance: 0.778324, annuity: 0.221676 },
        92: { insurance: 0.812477, annuity: 0.187523 },
        93: { insurance: 0.814243, annuity: 0.185757 },
        94: { insurance: 0.815899, annuity: 0.184101 },
        95: { insurance: 0.817459, annuity: 0.182541 },
        96: { insurance: 0.852078, annuity: 0.147923 },
        97: { insurance: 0.853828, annuity: 0.146172 },
        98: { insurance: 0.855484, annuity: 0.144516 },
        99: { insurance: 0.857067, annuity: 0.142933 },
        100: { insurance: 0.858563, annuity: 0.141437 },
    },
    female: {
        64: { insurance: 0.323971, annuity: 0.676029 },
        65: { insurance: 0.335558, annuity: 0.664442 },
        66: { insurance: 0.338192, annuity: 0.661808 },
        67: { insurance: 0.350929, annuity: 0.649071 },
        68: { insurance: 0.364563, annuity: 0.635437 },
        69: { insurance: 0.379150, annuity: 0.620850 },
        70: { insurance: 0.394718, annuity: 0.605282 },
        71: { insurance: 0.411324, annuity: 0.588677 },
        72: { insurance: 0.428932, annuity: 0.571068 },
        73: { insurance: 0.433342, annuity: 0.566658 },
        74: { insurance: 0.451988, annuity: 0.548012 },
        75: { insurance: 0.471516, annuity: 0.528484 },
        76: { insurance: 0.491936, annuity: 0.508064 },
        77: { insurance: 0.513317, annuity: 0.486683 },
        78: { insurance: 0.517460, annuity: 0.482540 },
        79: { insurance: 0.539902, annuity: 0.460098 },
        80: { insurance: 0.563412, annuity: 0.436588 },
        81: { insurance: 0.567375, annuity: 0.432625 },
        82: { insurance: 0.592083, annuity: 0.407917 },
        83: { insurance: 0.617950, annuity: 0.382050 },
        84: { insurance: 0.621864, annuity: 0.378136 },
        85: { insurance: 0.649014, annuity: 0.350987 },
        86: { insurance: 0.652821, annuity: 0.347179 },
        87: { insurance: 0.681274, annuity: 0.318726 },
        88: { insurance: 0.710674, annuity: 0.289326 },
        89: { insurance: 0.714733, annuity: 0.285267 },
        90: { insurance: 0.718556, annuity: 0.281444 },
        91: { insurance: 0.749294, annuity: 0.250706 },
        92: { insurance: 0.753277, annuity: 0.246723 },
        93: { insurance: 0.757126, annuity: 0.242874 },
        94: { insurance: 0.788994, annuity: 0.211006 },
        95: { insurance: 0.793285, annuity: 0.206715 },
        96: { insurance: 0.797611, annuity: 0.202389 },
        97: { insurance: 0.830406, annuity: 0.169594 },
        98: { insurance: 0.835220, annuity: 0.164780 },
        99: { insurance: 0.839663, annuity: 0.160337 },
        100: { insurance: 0.843662, annuity: 0.156338 },
    },
} as const;

export type CarePlusSplitTable = typeof CAREPLUS_SPLIT;
